import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "@/data/images";

// One paragraph bridge: DOCM context, then the rest of the page belongs to 11.11
export default function AboutDocm() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-28 overflow-hidden grain"
    >
      <div className="max-w-[1300px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-6 order-2 lg:order-1"
          >
            <div className="relative rounded-[2rem] overflow-hidden border border-docm-border bg-docm-linen/40 shadow-[0_30px_70px_-35px_rgba(28,32,30,0.3)]">
              <img
                src={IMG.bridgeMoment}
                alt="A diverse crowd gathered under a DECLARATION OF CONSCIOUSNESS banner — One Humanity, One Consciousness, One Shared Future"
                loading="lazy"
                decoding="async"
                className="block w-full h-auto"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-6 order-1 lg:order-2"
          >
            <span className="label-eyebrow text-docm-terracotta">DoCM & The Conscious Pathway</span>
            <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl text-docm-ink leading-[1.05]">
              A declaration for the{" "}
              <span className="font-display italic text-docm-moss">age of consciousness.</span>
            </h2>
            <div className="mt-7 w-16 h-px bg-docm-terracotta" />
            <p className="mt-7 text-base md:text-lg text-docm-inkSoft font-sans leading-relaxed">
              In <em className="text-docm-ink not-italic font-medium">1776</em>, the Declaration of Independence voiced a nation&rsquo;s aspiration for freedom. Today, the world calls for a larger manifesto — the{" "}
              <em className="text-docm-ink not-italic font-medium">Declaration of Consciousness Movement</em> — upholding{" "}
              <em className="text-docm-ink not-italic font-medium">
                nonviolence, women&rsquo;s rights, equality, inclusivity, righteousness, freedom of thought, unity of all religions, planet earth
              </em>{" "}
              as the intrinsic inherent rights of every human across cultures and all nations.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                to="/about"
                data-testid="about-story-cta"
                className="btn-secondary group"
              >
                Our Story &amp; the 9 Principles
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/1111"
                data-testid="about-summit-jump"
                className="text-sm font-medium text-docm-moss hover:text-docm-ink transition-colors inline-flex items-center gap-2"
              >
                <span className="w-8 h-px bg-docm-moss" />
                Learn about 11·11
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
